<template>
  <form class="form" @submit.prevent="$emit('submit')">
    <div
      v-for="field in fields"
      :key="field.key"
      class="form__field"
      :class="{ 'form__field--half': field.halfSize }"
    >
      <component
        :is="field.component"
        v-bind="field.props"
        :value="value[field.key]"
        @input="val => handleInput(val, field.key)"
      />
    </div>
  </form>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    fields: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleInput (val, key) {
      this.$emit('input', { ...this.value, [key]: val })
    }
  }
}
</script>

<style lang="scss" scoped>
  .form {
    width: 100%;
    padding: 32px 0;
    display: flex;
    flex-wrap: wrap;

    &__field {
      width: 100%;
      flex-basis: 100%;
      padding-bottom: 20px;

      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        &--half {
          flex-basis: auto !important;
        }
      }

      @include media-up(md) {
        &--half {
          width: 50%;
          flex-basis: 50%;

          &:nth-child(even) {
            padding-left: 20px;
          }

          &:nth-child(odd) {
            padding-right: 20px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Form.vue